// extracted by mini-css-extract-plugin
var _1 = "styles-module__ldsEllipsis___Qk5eZ";
var _2 = "styles-module__lds-ellipsis1___EXGnN";
var _3 = "styles-module__lds-ellipsis2___lYiMF";
var _4 = "styles-module__lds-ellipsis3___HqLLo";
export { _1 as "ldsEllipsis", _2 as "ldsEllipsis1", _3 as "ldsEllipsis2", _4 as "ldsEllipsis3" }
